import { getWebpImages } from "../src/services/aircraftImageService";

export async function convertAircraftImages() {
	const images = await getWebpImages(1);
	console.info(images.length);
	//  return;
	const dirHandle = await window.showDirectoryPicker();
	console.info("dirHandle...", dirHandle);
	//return;
	for (let img of images) {
		await convertImage(dirHandle, img);
		return;
	}
}

async function convertImage(dirHandle, img) {
	const filename = `${img.image_id}.webp`;

	const blob = atob(img.aircraft_image);
	console.info("blob...", blob.length);
	const fileHandle = await dirHandle.getFileHandle(filename);
	console.info("fileHandle...", fileHandle);
	await writeFile(fileHandle, blob);
}

async function writeFile(fileHandle, contents) {
	// Create a FileSystemWritableFileStream to write to.
	const writable = await fileHandle.createWritable();

	// Write the contents of the file to the stream.
	await writable.write(contents);

	// Close the file and write the contents to disk.
	await writable.close();
}
